import loginBg from "./assets/login-bg.jpg";
import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import movieData from "./data/letterboxd_full_genre_dataset.json";
import "./fonts.css";
import "./App.css";
import resolveMovieAlias from "./data/movieAliases";
import movieQuotes from "./data/movieQuotes";

import CineWord from "./components/CineWord";

import { auth } from "./firebase";

import { functions } from "./firebase";

import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendEmailVerification,
} from "firebase/auth";

import { httpsCallable } from "firebase/functions";

import { signInWithGoogle } from "./googleAuth";

import {
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
  query,
  orderBy,
  addDoc,
  deleteDoc,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore";

import { db } from "./firebase";
import movieGamePuzzles from "./data/movieGamePuzzles";


export default function App() {
  const [watched, setWatched] = useState(() => {
    const saved = localStorage.getItem("letterboxdChecklistWatched");
    return saved ? JSON.parse(saved) : {};
  });

  const lockedCategories = [
  "Criterion Collection",
  "A24 Films",
  "MUBI Catalog",
  "Sci-Fi",
  "Feel Good Movies",
  "Political Movies",
];
  const [premium, setPremium] = useState(false);
  const [checkingPremium, setCheckingPremium] = useState(true);

  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isOpeningCategory, setIsOpeningCategory] = useState(false);

  const [slowBurnMode, setSlowBurnMode] = useState(false);
  const [nowPlaying, setNowPlaying] = useState(null);
  const [afterHoursFullscreen, setAfterHoursFullscreen] = useState(false);
  const audioRef = useRef(null);

  const [user, setUser] = useState(null);
  const [openMemoryId, setOpenMemoryId] = useState(null);
  const [openedYear, setOpenedYear] = useState(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [authMode, setAuthMode] = useState("login");
  const [authError, setAuthError] = useState("");
  const [loadingSignup, setLoadingSignup] = useState(false);
  const [loadingLogin, setLoadingLogin] = useState(false);

  const [rtRatings, setRtRatings] = useState({});
  const [loadingRatings, setLoadingRatings] = useState({});
  const [awards, setAwards] = useState({});
  const [plots, setPlots] = useState({});
  const [loadingPlots, setLoadingPlots] = useState({});

  const [customLists, setCustomLists] = useState(() => {
    const saved = localStorage.getItem("customLetterboxdLists");
    return saved ? JSON.parse(saved) : [];
  });
const [movieGuess, setMovieGuess] = useState(null);
const [gameSeed, setGameSeed] = useState(0);
const [sweepTiles, setSweepTiles] = useState([]);
const [sweepGameOver, setSweepGameOver] = useState(false);
const [sweepMessage, setSweepMessage] = useState("");
const [showSweepGame, setShowSweepGame] = useState(false);
const [puzzlesAnswered, setPuzzlesAnswered] = useState(0);
  const [visibleMovies, setVisibleMovies] = useState({});

  const [listName, setListName] = useState("");
  const [listUrl, setListUrl] = useState("");
  const [tonightsPick, setTonightsPick] = useState(null);

  const apiKey = process.env.REACT_APP_OMDB_KEY;

  const [showHowToUse, setShowHowToUse] = useState(false);
  const [watchInspiredQuote, setWatchInspiredQuote] = useState(null);
  const [showWatchInspired, setShowWatchInspired] = useState(false);
const saveUserData = async (updates) => {
  if (!user) return;

  await setDoc(
    doc(db, "users", user.uid),
    updates,
    { merge: true }
  );
};

  const handleWatchInspired = () => {
    if (showWatchInspired) {
      setShowWatchInspired(false);
      return;
    }

    setWatchInspiredQuote(getDailyQuote());
    setShowWatchInspired(true);
  };

  const [journalText, setJournalText] = useState("");
  const [journalTitle, setJournalTitle] = useState("");
  const [showMemoryArchive, setShowMemoryArchive] = useState(false);
const [journalEntries, setJournalEntries] = useState([]);
const [savingMemory, setSavingMemory] = useState(false);
const [deletingMemoryId, setDeletingMemoryId] = useState(null);

  const getDailyQuote = () => {
  const dayNumber = Math.floor(
    new Date().getTime() / (1000 * 60 * 60 * 24)
  );

  return movieQuotes[dayNumber % movieQuotes.length];
};

  const [currentTime, setCurrentTime] = useState("");
const [userLocation, setUserLocation] = useState("Location unavailable");

  const toggleMovie = (category, title) => {
    const key = `${category}-${title}`;

    setWatched((prev) => {
      const updated = { ...prev, [key]: !prev[key] };

      localStorage.setItem(
        "letterboxdChecklistWatched",
        JSON.stringify(updated)
      );

      saveUserData({
  watched: updated,
});

      return updated;
    });
  };

  const refreshCategory = (category) => {
    const allMovies = movieData[category] || [];

    const shuffled = [...allMovies].sort(() => Math.random() - 0.5);

    const unseenMovies = shuffled.filter(([title]) => {
      return !watched[`${category}-${title}`];
    });

    const nextMovies =
      unseenMovies.length >= 50
        ? unseenMovies.slice(0, 50)
        : shuffled.slice(0, 50);

    setVisibleMovies((prev) => ({
      ...prev,
      [category]: nextMovies,
    }));
  };

  const openLetterboxd = (title) => {
  const letterboxdAliases = {
    Seven: "Se7en",
  };

  const letterboxdTitle = letterboxdAliases[title] || title;

  const slug = letterboxdTitle
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

  const url = `https://letterboxd.com/film/${slug}/`;

  window.location.assign(url);
};

  const addCustomList = () => {
    if (!listName.trim() || !listUrl.trim()) return;

    const updatedLists = [
      ...customLists,
      {
        name: listName.trim(),
        url: listUrl.trim(),
      },
    ];

    setCustomLists(updatedLists);

    localStorage.setItem(
      "customLetterboxdLists",
      JSON.stringify(updatedLists)
    );

    setListName("");
    setListUrl("");
  };

  const deleteCustomList = (url) => {
    const updatedLists = customLists.filter((list) => list.url !== url);

    setCustomLists(updatedLists);

    localStorage.setItem(
      "customLetterboxdLists",
      JSON.stringify(updatedLists)
    );
  };

  const OMDB_CACHE_PREFIX = "cineaste-omdb-v9:";
  const OMDB_CACHE_TTL = 30 * 24 * 60 * 60 * 1000;

  const normalizeMovieTitle = (value = "") =>
  String(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’‘]/g, "'")
    .replace(/[–—]/g, "-")
    .replace(/&/g, " and ")
    .replace(/\biii\b/gi, "3")
    .replace(/\bviii\b/gi, "8")
    .replace(/\bvii\b/gi, "7")
    .replace(/\bvi\b/gi, "6")
    .replace(/\biv\b/gi, "4")
    .replace(/\bii\b/gi, "2")
    .replace(/\bix\b/gi, "9")
    .replace(/\bx\b/gi, "10")
    .replace(/\bv\b/gi, "5")
    .replace(/[^a-z0-9]+/gi, " ")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

    const convertRomanSequelsToNumbers = (title = "") =>
  title
    .replace(/\biii\b/gi, "3")
    .replace(/\bviii\b/gi, "8")
    .replace(/\bvii\b/gi, "7")
    .replace(/\bvi\b/gi, "6")
    .replace(/\biv\b/gi, "4")
    .replace(/\bii\b/gi, "2")
    .replace(/\bix\b/gi, "9")
    .replace(/\bx\b/gi, "10")
    .replace(/\bv\b/gi, "5");

const convertNumberSequelsToRoman = (title = "") =>
  title
    .replace(/\b10\b/g, "X")
    .replace(/\b9\b/g, "IX")
    .replace(/\b8\b/g, "VIII")
    .replace(/\b7\b/g, "VII")
    .replace(/\b6\b/g, "VI")
    .replace(/\b5\b/g, "V")
    .replace(/\b4\b/g, "IV")
    .replace(/\b3\b/g, "III")
    .replace(/\b2\b/g, "II");

const createOmdbSearchTitles = (title = "") => {
  const cleaned = cleanMovieTitle(title);

  const withoutPunctuation = cleaned
    .replace(/[–—-]/g, " ")
    .replace(/[:.,!?'"()[\]]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const withoutChapterWords = withoutPunctuation
    .replace(/\b(chapter|part|volume|vol)\b/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

  const withoutSubtitle = cleaned
    .split(":")[0]
    .replace(/\s+/g, " ")
    .trim();

  const variants = [
    cleaned,
    withoutPunctuation,
    withoutChapterWords,
    withoutSubtitle,
    convertRomanSequelsToNumbers(cleaned),
    convertRomanSequelsToNumbers(withoutPunctuation),
    convertNumberSequelsToRoman(cleaned),
    convertNumberSequelsToRoman(withoutPunctuation),
  ];

  return variants
    .map((variant) => variant.replace(/\s+/g, " ").trim())
    .filter(
      (variant, index, array) =>
        variant && array.indexOf(variant) === index
    );
};

const getTitleWords = (title = "") =>
  normalizeMovieTitle(title)
    .split(" ")
    .filter(
      (word) =>
        word &&
        ![
          "the",
          "a",
          "an",
          "of",
          "and",
          "in",
          "on",
          "to",
          "for",
        ].includes(word)
    );

  const cleanMovieTitle = (title = "") =>
  title
    .replace(/\(\d{4}\)/g, "")
    .replace(/\[\d{4}\]/g, "")
    .replace(/\.\.\.$/, "")
    .replace(/[’]/g, "'")
    .replace(/[–—]/g, "-")
    .replace(/\s+/g, " ")
    .trim();

  const extractMovieYear = (title = "") =>
    title.match(/[\[(](\d{4})[\])]/)?.[1] || "";

  const getCachedOmdbMovie = (cacheKey) => {
    try {
      const raw = localStorage.getItem(
        `${OMDB_CACHE_PREFIX}${cacheKey}`
      );

      if (!raw) {
        return null;
      }

      const cached = JSON.parse(raw);

      if (
        !cached?.savedAt ||
        Date.now() - cached.savedAt > OMDB_CACHE_TTL
      ) {
        localStorage.removeItem(
          `${OMDB_CACHE_PREFIX}${cacheKey}`
        );

        return null;
      }

      return cached.data || null;
    } catch (error) {
      console.error("Could not read OMDb cache:", error);
      return null;
    }
  };

  const cacheOmdbMovie = (cacheKey, data) => {
    try {
      localStorage.setItem(
        `${OMDB_CACHE_PREFIX}${cacheKey}`,
        JSON.stringify({
          savedAt: Date.now(),
          data,
        })
      );
    } catch (error) {
      console.error("Could not save OMDb cache:", error);
    }
  };

  const requestOmdb = async (params) => {
    if (!apiKey) {
      throw new Error("REACT_APP_OMDB_KEY is missing.");
    }

    const queryParams = new URLSearchParams({
      apikey: apiKey,
      ...params,
    });

    const response = await fetch(
      `https://www.omdbapi.com/?${queryParams.toString()}`
    );

    if (!response.ok) {
      throw new Error(
        `OMDb request failed with status ${response.status}.`
      );
    }

    const data = await response.json();

    return data;
  };

    const scoreOmdbCandidate = (
  candidate,
  requestedTitle,
  requestedYear
) => {
  const requested = normalizeMovieTitle(requestedTitle);
  const candidateTitle = normalizeMovieTitle(
    candidate?.Title || ""
  );

  if (!candidateTitle) {
    return -1000;
  }

  let score = 0;

  if (candidateTitle === requested) {
    score += 150;
  } else if (
    candidateTitle.startsWith(requested) ||
    requested.startsWith(candidateTitle)
  ) {
    score += 75;
  }

  const requestedWords = getTitleWords(requestedTitle);
  const candidateWords = getTitleWords(
    candidate?.Title || ""
  );

  const sharedWords = requestedWords.filter((word) =>
    candidateWords.includes(word)
  );

  const wordSimilarity =
    sharedWords.length /
    Math.max(
      requestedWords.length,
      candidateWords.length,
      1
    );

  score += wordSimilarity * 80;

  const requestedNumber =
    requested.match(/\b(2|3|4|5|6|7|8|9|10)\b/)?.[1];

  const candidateNumber =
    candidateTitle.match(
      /\b(2|3|4|5|6|7|8|9|10)\b/
    )?.[1];

  if (requestedNumber && candidateNumber) {
    if (requestedNumber === candidateNumber) {
      score += 60;
    } else {
      score -= 80;
    }
  }

  if (
    requestedYear &&
    String(candidate?.Year || "").slice(0, 4) ===
      String(requestedYear)
  ) {
    score += 50;
  }

  if (candidate?.Type === "movie") {
    score += 20;
  } else {
    score -= 50;
  }

  return score;
};

  const searchBestOmdbMatch = async (
  requestedTitle,
  requestedYear
) => {
  const searchAttempts =
    createOmdbSearchTitles(requestedTitle);

  let bestCandidate = null;
  let bestScore = -Infinity;

  for (const searchTitle of searchAttempts) {
    try {
      const searchData = await requestOmdb({
        s: searchTitle,
        type: "movie",
        ...(requestedYear
          ? { y: requestedYear }
          : {}),
      });

      if (!Array.isArray(searchData.Search)) {
        continue;
      }

      for (const candidate of searchData.Search) {
        const score = scoreOmdbCandidate(
          candidate,
          requestedTitle,
          requestedYear
        );

        if (score > bestScore) {
          bestScore = score;
          bestCandidate = candidate;
        }
      }

      if (bestScore >= 170) {
        break;
      }
    } catch (error) {
      console.warn(
        `OMDb search failed for "${searchTitle}":`,
        error
      );
    }
  }

  return bestScore >= 70
    ? bestCandidate
    : null;
};

  const fetchOmdbMovie = async (title, plotLength = "short") => {
  const alias = resolveMovieAlias(title);

  const aliasTitle = alias.title || cleanMovieTitle(title);
  const aliasYear = alias.year || extractMovieYear(title);
  const aliasImdbId = alias.imdbId || "";

  const cacheKey = normalizeMovieTitle(
    `${aliasImdbId || aliasTitle}-${aliasYear || "any"}-${plotLength}`
  );

  const cached = getCachedOmdbMovie(cacheKey);

  if (cached) {
    return cached;
  }

  try {
    // 1. Exact IMDb ID lookup
    if (aliasImdbId) {
      const exactData = await requestOmdb({
        i: aliasImdbId,
        plot: plotLength,
      });

      if (exactData?.Response === "True") {
        cacheOmdbMovie(cacheKey, exactData);
        return exactData;
      }
    }

    // 2. Corrected exact-title lookup
    const exactTitleData = await requestOmdb({
      t: aliasTitle,
      type: "movie",
      plot: plotLength,
      ...(aliasYear ? { y: aliasYear } : {}),
    });

    if (
      exactTitleData?.Response === "True" &&
      exactTitleData?.Type === "movie"
    ) {
      cacheOmdbMovie(cacheKey, exactTitleData);
      return exactTitleData;
    }

    // 3. Smart fallback search
    const searchData = await searchBestOmdbMatch(
      aliasTitle,
      aliasYear
    );

    if (searchData?.imdbID) {
      const fullData = await requestOmdb({
        i: searchData.imdbID,
        plot: plotLength,
      });

      if (fullData?.Response === "True") {
        cacheOmdbMovie(cacheKey, fullData);
        return fullData;
      }
    }

    throw new Error(
      exactTitleData?.Error ||
        `No OMDb match found for "${title}".`
    );
  } catch (error) {
    console.error(`OMDb lookup failed for "${title}":`, error);
    throw error;
  }
};

    const fetchRottenTomatoesRating = async (title) => {
    if (rtRatings[title] || loadingRatings[title]) {
      return;
    }

    setLoadingRatings((prev) => ({
      ...prev,
      [title]: true,
    }));

    try {
      const data = await fetchOmdbMovie(title, "short");

      const rottenTomatoes = Array.isArray(data.Ratings)
        ? data.Ratings.find(
            (rating) =>
              rating.Source === "Rotten Tomatoes"
          )
        : null;

      setRtRatings((prev) => ({
        ...prev,
        [title]:
          rottenTomatoes?.Value ||
          "RT score unavailable",
      }));
    } catch (error) {
      console.error(
        `Could not load Rotten Tomatoes score for ${title}:`,
        error
      );

      setRtRatings((prev) => ({
        ...prev,
        [title]: "RT score unavailable",
      }));
    } finally {
      setLoadingRatings((prev) => ({
        ...prev,
        [title]: false,
      }));
    }
  };

  const fetchMovieAwards = async (title) => {
  try {
    const data = await fetchOmdbMovie(title, "short");

    setAwards((prev) => ({
      ...prev,
      [title]:
        data?.Awards &&
        data.Awards !== "N/A" &&
        data.Awards.trim() !== ""
          ? data.Awards
          : "Awards information unavailable",
    }));
  } catch (error) {
    console.error(
      `Could not load awards for ${title}:`,
      error
    );

    setAwards((prev) => ({
      ...prev,
      [title]: "Awards information unavailable",
    }));
  }
};

  const fetchMoviePlot = async (title) => {
  if (loadingPlots[title]) {
    return;
  }

  setLoadingPlots((prev) => ({
    ...prev,
    [title]: true,
  }));

  try {
    const data = await fetchOmdbMovie(title, "short");

    const plot =
      data?.Plot &&
      data.Plot !== "N/A" &&
      data.Plot.trim() !== ""
        ? data.Plot
        : null;

    setPlots((prev) => ({
      ...prev,
      [title]: plot || "Plot information unavailable",
    }));
  } catch (error) {
    console.error(
      `Could not load plot for ${title}:`,
      error
    );

    setPlots((prev) => ({
      ...prev,
      [title]: "Plot information unavailable",
    }));
  } finally {
    setLoadingPlots((prev) => ({
      ...prev,
      [title]: false,
    }));
  }
};

  const visibleCategories = useMemo(() => {
    const query = search.toLowerCase().trim();

    if (!query) return movieData;

    const result = {};

    Object.entries(movieData).forEach(([category, movies]) => {
      const filteredMovies = movies.filter(([title]) =>
        title.toLowerCase().includes(query)
      );

      if (filteredMovies.length > 0) {
        result[category] = filteredMovies;
      }
    });

    return result;
  }, [search]);

  const moviesToShow = selectedCategory
    ? visibleMovies[selectedCategory] ||
      movieData[selectedCategory]?.slice(0, 50) ||
      []
    : [];

  const getProgress = (category, movies) => {
    if (!movies || movies.length === 0) return 0;

    const watchedCount = movies.filter(
      ([title]) => watched[`${category}-${title}`]
    ).length;

    return Math.round((watchedCount / movies.length) * 100);
  };

  const totalMovies = Object.values(movieData).flat().length;

  const watchedTotal = Object.entries(movieData).reduce(
    (count, [category, movies]) =>
      count +
      movies.filter(([title]) => watched[`${category}-${title}`]).length,
    0
  );

  const somaStations = [
    {
      title: "Indie Pop Rocks",
      stationId: "indiepop",
      mood: "melancholic indie, soft nights, reflective walks",
      stream: "https://ice5.somafm.com/indiepop-128-mp3",
    },
    {
      title: "Left Coast 70s",
      stationId: "seventies",
      mood: "warm vinyl evenings, faded California sunsets",
      stream: "https://ice5.somafm.com/seventies-128-mp3",
    },
    {
      title: "Groove Salad Classic",
      stationId: "gsclassic",
      mood: "ambient glow, quiet apartments, rainy windows",
      stream: "https://ice5.somafm.com/gsclassic-128-mp3",
    },
    {
      title: "Underground 80s",
      stationId: "u80s",
      mood: "neon nostalgia, synth shadows, midnight drives",
      stream: "https://ice5.somafm.com/u80s-128-mp3",
    },
    {
      title: "Illinois Street Lounge",
      stationId: "illstreet",
      mood: "film noir lounges, old cocktails, late conversations",
      stream: "https://ice5.somafm.com/illstreet-128-mp3",
    },
    {
      title: "n5MD Radio",
      stationId: "n5md",
      mood: "dreamlike electronica, distant lights, drifting thoughts",
      stream: "https://ice5.somafm.com/n5md-128-mp3",
    },
  ];

  const [somaStation, setSomaStation] = useState(somaStations[0]);

  const playRadioSafely = () => {
    setTimeout(() => {
      const player = audioRef.current;

      if (!player) return;

      player.load();

      player.play().catch(() => {
        console.log("Browser blocked or interrupted playback.");
      });
    }, 350);
  };

  const changeSomaStation = () => {
    const otherStations = somaStations.filter(
      (station) => station.stationId !== somaStation.stationId
    );

    const randomStation =
      otherStations[Math.floor(Math.random() * otherStations.length)];

    setNowPlaying({
      track: "Loading current track...",
    });

    setSomaStation(randomStation);

    playRadioSafely();
  };

  useEffect(() => {
    if (!slowBurnMode || !somaStation?.stationId) return;

    let alive = true;

    const fetchNowPlaying = async () => {
      try {
        const response = await fetch(
          `/api/soma-now?station=${somaStation.stationId}`
        );

        const data = await response.json();

        console.log("Now Playing API:", data);

        if (alive) {
          setNowPlaying(data);
        }
      } catch (error) {
        console.error("Now playing failed:", error);

        if (alive) {
          setNowPlaying({
            track: "Track info unavailable",
          });
        }
      }
    };

    setNowPlaying({
      track: "Loading current track...",
    });

    fetchNowPlaying();

    const interval = setInterval(fetchNowPlaying, 30000);

    return () => {
      alive = false;
      clearInterval(interval);
    };
  }, [slowBurnMode, somaStation.stationId]);

  useEffect(() => {
    const isAbortError = (message) =>
      String(message).toLowerCase().includes("user aborted a request");

    const handleWindowError = (event) => {
      if (isAbortError(event.message)) {
        event.preventDefault();
        return false;
      }
    };

    const handleUnhandledRejection = (event) => {
      if (isAbortError(event.reason?.message || event.reason)) {
        event.preventDefault();
      }
    };

    window.addEventListener("error", handleWindowError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleWindowError);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, []);

  const startSlowBurn = () => {
    setSlowBurnMode(true);
    playRadioSafely();
  };

  const stopSlowBurn = () => {
    setSlowBurnMode(false);
    setAfterHoursFullscreen(false);

    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

useEffect(() => {
  let unsubscribeUserDoc = null;

  const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser);

    // Stop listening to the previous account
    if (unsubscribeUserDoc) {
      unsubscribeUserDoc();
      unsubscribeUserDoc = null;
    }

    if (!currentUser) {
      setWatched({});
      setPremium(false);
      setCheckingPremium(false);
      return;
    }

    setCheckingPremium(true);

    const userRef = doc(db, "users", currentUser.uid);

    unsubscribeUserDoc = onSnapshot(
      userRef,
      async (userSnap) => {
        if (userSnap.exists()) {
          const data = userSnap.data();

          setWatched(data.watched || {});
          setPremium(data.premium === true);

          if (data.tonightsPick) {
            setTonightsPick(data.tonightsPick);
          }

          if (data.watchInspiredQuote) {
            setWatchInspiredQuote(data.watchInspiredQuote);
          }

          if (data.customLists) {
            setCustomLists(data.customLists);
          }
        } else {
          // Ensure every authenticated account has a user document
          await setDoc(
            userRef,
            {
              email: currentUser.email || "",
              premium: false,
              createdAt: serverTimestamp(),
            },
            { merge: true }
          );

          setWatched({});
          setPremium(false);
        }

        setCheckingPremium(false);
      },
      (error) => {
        console.error("Could not load user data:", error);
        setPremium(false);
        setCheckingPremium(false);
      }
    );
  });

  return () => {
    unsubscribeAuth();

    if (unsubscribeUserDoc) {
      unsubscribeUserDoc();
    }
  };
}, []);

  const handleAuth = async () => {
  setAuthError("");

  if (authMode === "login") {
    setLoadingLogin(true);
  } else {
    setLoadingSignup(true);
  }

  try {
    if (authMode === "login") {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      await userCredential.user.reload();

// Check the user's Firestore document
const userSnap = await getDoc(doc(db, "users", userCredential.user.uid));

const isPremium =
  userSnap.exists() && userSnap.data().premium === true;

if (!isPremium && !userCredential.user.emailVerified) {
  await auth.signOut();

  setAuthError(
    "Please verify your email before entering Cineaste. Check your inbox for the verification email."
  );

  return;
}
   } else {
  const userCredential = await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );

  // Create this user's Firestore document immediately
  await setDoc(
    doc(db, "users", userCredential.user.uid),
    {
      email: userCredential.user.email,
      premium: false,
      createdAt: serverTimestamp(),
    },
    { merge: true }
  );

  const sendVerificationEmail = httpsCallable(functions, "sendCustomVerificationEmail");
await sendVerificationEmail();

  await auth.signOut();

  alert(
    "✨ Welcome to Cineaste!\n\nWe've sent a verification email to your inbox. If it doesn't arrive within a minute, please check your Spam or Junk folder.\n\nPlease click the verification link before signing in."
  );

  setAuthMode("login");
}
   } catch (error) {
    setAuthError(error.message);
  } finally {
    setLoadingLogin(false);
    setLoadingSignup(false);
  }
};

  const handleLogout = async () => {
    await signOut(auth);
  };

  const chooseTonightsPick = () => {
    if (!selectedCategory || selectedCategory === "My Added Lists") return;

    const now = Date.now();
    const savedLockUntil = Number(localStorage.getItem("tonightsPickLockUntil"));

    if (savedLockUntil && now < savedLockUntil) {
      alert("Tonight’s Pick is resting. Come back in 3 hours.");
      return;
    }

    if (savedLockUntil && now >= savedLockUntil) {
      localStorage.removeItem("tonightsPickLockUntil");
      localStorage.removeItem("tonightsPickCount");
    }

    const pickCount = Number(localStorage.getItem("tonightsPickCount")) || 0;

    if (pickCount >= 2) {
      const lockUntil = now + 3 * 60 * 60 * 1000;
      localStorage.setItem("tonightsPickLockUntil", lockUntil);
      alert("Tonight’s Pick is resting. Come back in 3 hours.");
      return;
    }

    const availableMovies = moviesToShow.filter(([title]) => {
      return !watched[`${selectedCategory}-${title}`];
    });

    const pool = availableMovies.length > 0 ? availableMovies : moviesToShow;

    if (pool.length === 0) return;

    const randomMovie = pool[Math.floor(Math.random() * pool.length)];

    setTonightsPick(randomMovie);
    localStorage.setItem("tonightsPickCount", pickCount + 1);
  };

  const [journalSaved, setJournalSaved] = useState(false);

  const getCinemaProfile = () => {
    const completedByCategory = Object.entries(movieData).map(
      ([category, movies]) => {
        const watchedCount = movies.filter(
          ([title]) => watched[`${category}-${title}`]
        ).length;

        return { category, watchedCount };
      }
    );

    const topCategory = completedByCategory.sort(
      (a, b) => b.watchedCount - a.watchedCount
    )[0];

    const totalWatched = completedByCategory.reduce(
      (sum, item) => sum + item.watchedCount,
      0
    );

    let profileTitle = "The Quiet Viewer";
    let nextTitle = "The Night Drifter";
    let nextGoal = 25;

    if (totalWatched >= 25) {
      profileTitle = "The Night Drifter";
      nextTitle = "The Screen Wanderer";
      nextGoal = 75;
    }

    if (totalWatched >= 75) {
      profileTitle = "The Screen Wanderer";
      nextTitle = "The Projectionist";
      nextGoal = 150;
    }

    if (totalWatched >= 150) {
      profileTitle = "The Projectionist";
      nextTitle = "The After-Hours Curator";
      nextGoal = 300;
    }

    if (totalWatched >= 300) {
      profileTitle = "The After-Hours Curator";
      nextTitle = "The Film Archivist";
      nextGoal = 500;
    }

    if (totalWatched >= 500) {
      profileTitle = "The Film Archivist";
      nextTitle = "The Neon Cinephile";
      nextGoal = 800;
    }

    if (totalWatched >= 800) {
      profileTitle = "The Neon Cinephile";
      nextTitle = "Keeper of the Late Screening";
      nextGoal = 1200;
    }

    if (totalWatched >= 1200) {
      profileTitle = "Keeper of the Late Screening";
      nextTitle = "The Cinema Ghost";
      nextGoal = 1700;
    }

    if (totalWatched >= 1700) {
      profileTitle = "The Cinema Ghost";
      nextTitle = "The Last Projectionist";
      nextGoal = 2200;
    }

    if (totalWatched >= 2200) {
      profileTitle = "The Last Projectionist";
      nextTitle = "Patron Saint of Cinema";
      nextGoal = 2600;
    }

    if (totalWatched >= 2600) {
      profileTitle = "Patron Saint of Cinema";
      nextTitle = "Final title reached";
      nextGoal = null;
    }

    return {
      totalWatched,
      topCategory: topCategory?.category || "None yet",
      profileTitle,
      nextTitle,
      nextGoal,
    };
  };

  const cinemaProfile = getCinemaProfile();

  useEffect(() => {
  const updateTime = () => {
    const now = new Date();

    setCurrentTime(
      now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };

  updateTime();

  const timer = setInterval(updateTime, 1000);

  return () => clearInterval(timer);
}, []);

useEffect(() => {
  if (!navigator.geolocation) {
    setUserLocation("Location unavailable");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      try {
        const { latitude, longitude } = position.coords;

        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );

        const data = await response.json();

        const city =
          data.address?.city ||
          data.address?.town ||
          data.address?.village ||
          data.address?.suburb ||
          "Current location";

        const country = data.address?.country || "";

        setUserLocation(`${city}${country ? `, ${country}` : ""}`);
      } catch {
        setUserLocation("Current location");
      }
    },
    () => {
      setUserLocation("Location permission off");
    }
  );
}, []);

useEffect(() => {
  if (!("mediaSession" in navigator)) return;

  const trackTitle =
    nowPlaying?.artist && nowPlaying?.song
      ? `${nowPlaying.artist} — ${nowPlaying.song}`
      : nowPlaying?.title || nowPlaying?.track || somaStation.title;

  navigator.mediaSession.metadata = new MediaMetadata({
    title: trackTitle,
    artist: "Cineaste After-Hours Radio",
    album: somaStation.title,
    artwork: [
      {
        src: "/popcorn1.png",
        sizes: "512x512",
        type: "image/png",
      },
    ],
  });

  navigator.mediaSession.setActionHandler(
    "nexttrack",
    () => {
      changeSomaStation();
    }
  );

  navigator.mediaSession.setActionHandler(
    "previoustrack",
    () => {
      changeSomaStation();
    }
  );

  navigator.mediaSession.setActionHandler("play", () => {
    audioRef.current?.play();
  });

  navigator.mediaSession.setActionHandler("pause", () => {
    audioRef.current?.pause();
  });
}, [nowPlaying, somaStation]);  

const [cineasteNews, setCineasteNews] = useState([]);
const [loadingNews, setLoadingNews] = useState(false);
const [showCineasteNews, setShowCineasteNews] = useState(false);
const [dispatchSource, setDispatchSource] =
  useState("letterboxd");

  const dispatchSources = {
  a24: "A24",
  criterion: "Criterion",
  letterboxd: "Letterboxd",
  mubi: "MUBI",
};

const dayNumber = Math.floor(
  new Date().getTime() / (1000 * 60 * 60 * 24)
);

const firstPuzzleIndex =
  (dayNumber * 2) % movieGamePuzzles.length;

const secondPuzzleIndex =
  (dayNumber * 2 + 1) % movieGamePuzzles.length;

const dailyGame =
  puzzlesAnswered === 0
    ? movieGamePuzzles[firstPuzzleIndex]
    : movieGamePuzzles[secondPuzzleIndex];

useEffect(() => {
  const savedDate = localStorage.getItem("cineastePuzzleDate");

  if (savedDate !== String(dayNumber)) {
    localStorage.setItem(
      "cineastePuzzleDate",
      String(dayNumber)
    );

    localStorage.setItem(
      "cineastePuzzleAnswered",
      "0"
    );

    setPuzzlesAnswered(0);
    setMovieGuess(null);
  } else {
    const savedAnswered = Number(
      localStorage.getItem("cineastePuzzleAnswered")
    );

    setPuzzlesAnswered(savedAnswered || 0);
  }
}, [dayNumber]);

const goToNextPuzzle = async () => {
  const nextCount = puzzlesAnswered + 1;

  setPuzzlesAnswered(nextCount);
  setMovieGuess(null);

  await saveMiniGameProgress({
    puzzlesAnswered: nextCount,
    movieGuess: null,
  });
};

const todayJournalKey = new Date().toLocaleDateString("en-CA");

const saveJournalToCloud = async (text) => {
  if (!user || !text.trim() || savingMemory) return;

  setSavingMemory(true);

  try {
    const newEntry = {
      title: journalTitle.trim() || "Untitled memory",
      text,
      station: somaStation.title,
      date: new Date().toLocaleDateString("en-CA"),
      createdAt: new Date().toISOString(),
    };

    const docRef = await addDoc(
      collection(db, "users", user.uid, "journals"),
      newEntry
    );

    setJournalEntries((prev) => [{ id: docRef.id, ...newEntry }, ...prev]);
    setJournalTitle("");
    setJournalText("");
    setJournalSaved(true);

    setTimeout(() => setJournalSaved(false), 1600);
  } finally {
    setSavingMemory(false);
  }
};

const loadJournalArchive = async () => {
  if (!user) return;

  const journalsRef = collection(
    db,
    "users",
    user.uid,
    "journals"
  );

  const journalsQuery = query(
    journalsRef,
    orderBy("createdAt", "desc")
  );

  const snapshot = await getDocs(journalsQuery);

  const entries = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  setJournalEntries(entries);
  setShowMemoryArchive(true);
};

const [memoryToDelete, setMemoryToDelete] = useState(null);

const deleteJournalEntry = async (entryId) => {
  if (!user || deletingMemoryId) return;

  setDeletingMemoryId(entryId);

  try {
    await deleteDoc(doc(db, "users", user.uid, "journals", entryId));

    setJournalEntries((prev) =>
      prev.filter((entry) => entry.id !== entryId)
    );

    if (openMemoryId === entryId) {
      setOpenMemoryId(null);
    }
  } finally {
    setDeletingMemoryId(null);
  }
};

const groupedJournalEntries = useMemo(() => {
  return Object.entries(
    journalEntries.reduce((groups, entry) => {
      const year = entry.date?.split("-")[0] || "Unknown";

      if (!groups[year]) {
        groups[year] = [];
      }

      groups[year].push(entry);

      return groups;
    }, {})
  );
}, [journalEntries]);

const screeningFortunes = [
  "You are due for:\nA black-and-white film\nA warm drink\nA slower evening",
  "You are due for:\nAn overlooked classic\nRain outside\nOne more film than planned",
  "You are due for:\nA foreign-language film\nDim lighting\nA quiet night in",
  "You are due for:\nAn unexpected favourite\nLate coffee\nA cancelled plan",
  "You are due for:\nA film you've been postponing\nComfort food\nAn open window",
  "You are due for:\nA director's deep cut\nSoft music\nA notebook nearby",
  "You are due for:\nA midnight screening\nNeon reflections\nA second viewing",
  "You are due for:\nA beautiful ending\nA calm evening\nA little less scrolling",
  "You are due for:\nA quiet drama\nFresh sheets\nA phone on silent",
  "You are due for:\nA strange little film\nA blanket\nNo explanations",
  "You are due for:\nA slow-burn romance\nLow volume\nA long pause after",
  "You are due for:\nA moody thriller\nBlue light\nA locked door",
  "You are due for:\nA gentle comedy\nSomething sweet\nAn early night",
  "You are due for:\nA tragic masterpiece\nTissues nearby\nA forgiving morning",
  "You are due for:\nA cult classic\nDim lamps\nA strange snack",
  "You are due for:\nA 90-minute film\nNo multitasking\nA clean watchlist",
  "You are due for:\nA film with rain\nWindow light\nA soft hoodie",
  "You are due for:\nA road movie\nRestless thoughts\nA map you won't use",
  "You are due for:\nA courtroom drama\nStrong tea\nAn opinionated group chat",
  "You are due for:\nA haunted house film\nOne lamp on\nBravery you don't have",
  "You are due for:\nA coming-of-age film\nOld memories\nA kind ending",
  "You are due for:\nA sci-fi classic\nQuiet awe\nA late-night Wikipedia spiral",
  "You are due for:\nA musical\nZero shame\nA private encore",
  "You are due for:\nA documentary\nCuriosity\nA new rabbit hole",
  "You are due for:\nA comfort rewatch\nSoft clothes\nNo guilt",
  "You are due for:\nA film under 100 minutes\nA clean room\nA fresh start",
  "You are due for:\nA film with subtitles\nPatience\nSomething beautiful",
  "You are due for:\nA messy romance\nA second drink\nA dramatic sigh",
  "You are due for:\nA quiet ending\nNo immediate rating\nA little reflection",
  "You are due for:\nA film your younger self needed\nA warm light\nA softer heart",
  "You are due for:\nA strange ending\nA confused pause\nA 3-star debate",
  "You are due for:\nA film from the 70s\nWarm grain\nA sleepy room",
  "You are due for:\nA film from the 80s\nSynth shadows\nA neon mood",
  "You are due for:\nA film from the 90s\nBig feelings\nA nostalgic snack",
  "You are due for:\nA film from the 2000s\nLow-rise chaos\nA guilty smile",
  "You are due for:\nA festival darling\nA careful mood\nA strong opinion",
  "You are due for:\nA hidden gem\nNo expectations\nA pleasant surprise",
  "You are due for:\nA divisive film\nA brave rating\nA dramatic review",
  "You are due for:\nA gentle animation\nA softer evening\nA small smile",
  "You are due for:\nA film with a great score\nHeadphones\nNo interruptions",
  "You are due for:\nA lonely city film\nStreetlights\nA quiet walk after",
  "You are due for:\nA coastal film\nSalt air\nA slow exhale",
  "You are due for:\nA winter film\nThick socks\nA warm blanket",
  "You are due for:\nA summer film\nOpen windows\nA restless heart",
  "You are due for:\nA film about friendship\nMessages unsent\nA grateful mood",
  "You are due for:\nA film about family\nA complicated feeling\nA cup of tea",
  "You are due for:\nA film about memory\nAn old photo\nA quiet ache",
  "You are due for:\nA film about grief\nGentleness\nNo rush",
  "You are due for:\nA film about obsession\nA dark room\nA raised eyebrow",
  "You are due for:\nA film about artists\nA messy desk\nA sudden idea",
  "You are due for:\nA mystery\nA suspicious snack\nA confident wrong guess",
  "You are due for:\nA heist film\nFast pacing\nA tiny adrenaline rush",
  "You are due for:\nA vampire film\nRed lighting\nA dramatic entrance",
  "You are due for:\nA ghost story\nSilence\nA blanket pulled higher",
  "You are due for:\nA sports film\nUnexpected tears\nA motivational stretch",
  "You are due for:\nA food film\nA proper meal\nNo watching hungry",
  "You are due for:\nA travel film\nA bookmarked destination\nA small escape",
  "You are due for:\nA film set at night\nLow brightness\nA sleeping city",
  "You are due for:\nA film set in one room\nStillness\nAttention",
  "You are due for:\nA film with trains\nPassing lights\nA wandering mind",
  "You are due for:\nA film with letters\nUnsent thoughts\nA soft ending",
  "You are due for:\nA film with dancing\nLoose shoulders\nA lighter mood",
  "You are due for:\nA film with silence\nNo snacks crunching\nFull attention",
  "You are due for:\nA film with a long take\nPatience\nA quiet reward",
  "You are due for:\nA film with a perfect final shot\nNo pausing\nA slow breath",
  "You are due for:\nA film you know nothing about\nNo trailer\nPure discovery",
  "You are due for:\nA film chosen by instinct\nNo reviews\nA tiny leap of faith",
  "You are due for:\nA film below 10k watches\nCuriosity\nA secret favourite",
  "You are due for:\nA film above 4 stars\nHigh hopes\nA strict mood",
  "You are due for:\nA film you might hate\nOpen mind\nA spicy review",
  "You are due for:\nA film you'll defend later\nConfidence\nA niche opinion",
  "You are due for:\nA film to watch alone\nStillness\nA private reaction",
  "You are due for:\nA film to watch with someone\nShared silence\nA look afterward",
  "You are due for:\nA film after work\nLoose clothes\nNo decisions left",
  "You are due for:\nA Sunday film\nLate breakfast\nA gentle reset",
  "You are due for:\nA Friday night film\nLow stakes\nA little indulgence",
  "You are due for:\nA rainy-day classic\nDim windows\nA second cup",
  "You are due for:\nA midnight oddity\nStrange lighting\nA questionable choice",
  "You are due for:\nA film with a doomed romance\nSoft lighting\nA dramatic mood",
  "You are due for:\nA film with a city at night\nReflections\nA quieter phone",
  "You are due for:\nA film with an unreliable narrator\nSuspicion\nA mental corkboard",
  "You are due for:\nA film with a beautiful poster\nAesthetic trust\nLow expectations",
  "You are due for:\nA film with a title you love\nCuriosity\nA screenshot for later",
  "You are due for:\nA film with an ending you sit with\nNo scrolling\nA quiet room",
  "You are due for:\nA film that feels like a dream\nSoft focus\nNo explanations",
  "You are due for:\nA film that feels like a diary\nHonesty\nA saved memory",
  "You are due for:\nA film that feels expensive\nGood lighting\nA little awe",
  "You are due for:\nA film that feels handmade\nPatience\nA tender mood",
  "You are due for:\nA film that feels cursed\nA brave heart\nLights left on",
  "You are due for:\nA film that feels holy\nSilence\nA respectful pause",
  "You are due for:\nA film that feels lonely\nStreet noise\nA soft blanket",
  "You are due for:\nA film that feels alive\nMovement\nA lighter chest",
  "You are due for:\nA film that feels like home\nComfort\nA familiar ache",
  "You are due for:\nA film that feels like leaving\nPacked emotions\nA long exhale",
  "You are due for:\nA film that feels like waiting\nPatience\nA window nearby",
  "You are due for:\nA film that feels like confession\nDim light\nAn honest journal entry",
  "You are due for:\nA film that feels like a secret\nLow volume\nA hidden tab",
  "You are due for:\nA film that feels like weather\nA blanket\nA mood shift",
  "You are due for:\nA film that feels like a song\nHeadphones\nA repeat listen",
  "You are due for:\nA film that feels like a painting\nStillness\nA beautiful pause",
  "You are due for:\nA film that feels like a dare\nCourage\nA bold rating",
  "You are due for:\nA film that feels like closure\nA deep breath\nA kinder night",
];

const todayKey = new Date().toLocaleDateString("en-CA");

const saveMiniGameProgress = async (updates) => {
  if (!user) return;

  await setDoc(
    doc(db, "users", user.uid, "gameProgress", todayKey),
    {
      ...updates,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};

const startLetterboxdSweep = () => {
  const gridSize = 5;
  const size = gridSize * gridSize;
  const bombCount = 3;

  const bombIndexes = new Set();

  while (bombIndexes.size < bombCount) {
    bombIndexes.add(Math.floor(Math.random() * size));
  }

  const getNeighbors = (index) => {
    const row = Math.floor(index / gridSize);
    const col = index % gridSize;
    const neighbors = [];

    for (let rowOffset = -1; rowOffset <= 1; rowOffset++) {
      for (let colOffset = -1; colOffset <= 1; colOffset++) {
        if (rowOffset === 0 && colOffset === 0) continue;

        const nextRow = row + rowOffset;
        const nextCol = col + colOffset;

        if (
          nextRow >= 0 &&
          nextRow < gridSize &&
          nextCol >= 0 &&
          nextCol < gridSize
        ) {
          neighbors.push(nextRow * gridSize + nextCol);
        }
      }
    }

    return neighbors;
  };

  const safeIndexes = [...Array(size).keys()].filter(
    (index) => !bombIndexes.has(index)
  );

  const masterpieceIndex =
    safeIndexes[Math.floor(Math.random() * safeIndexes.length)];

  const tiles = Array.from({ length: size }, (_, index) => {
    const nearbyBombs = getNeighbors(index).filter((neighbor) =>
      bombIndexes.has(neighbor)
    ).length;

    return {
      id: index,
      revealed: false,
      type: bombIndexes.has(index)
        ? "bomb"
        : index === masterpieceIndex
        ? "masterpiece"
        : "safe",
      nearbyBombs,
    };
  });

  setSweepTiles(tiles);
  setSweepGameOver(false);
  setSweepMessage("One cursed reel is hidden in tonight’s archive.");

  saveMiniGameProgress({
  sweepTiles: tiles,
  sweepGameOver: false,
  sweepMessage: "One cursed reel is hidden in tonight’s archive.",
});
};

const revealSweepTile = async (tileId) => {
  if (sweepGameOver) return;

  const selected = sweepTiles.find((tile) => tile.id === tileId);

  if (!selected || selected.revealed) return;

  if (selected.type === "bomb") {
    const bombRevealedTiles = sweepTiles.map((tile) => ({
      ...tile,
      revealed: tile.type === "bomb" ? true : tile.revealed,
    }));

    setSweepTiles(bombRevealedTiles);
    setSweepGameOver(true);
    setSweepMessage("💣 Bad movie night. The screening is cursed.");

    await saveMiniGameProgress({
      sweepTiles: bombRevealedTiles,
      sweepGameOver: true,
      sweepMessage: "💣 Bad movie night. The screening is cursed.",
    });

    return;
  }

  const updatedTiles = [...sweepTiles];

const revealConnected = (index) => {
  const tile = updatedTiles[index];

  if (!tile || tile.revealed) return;
  if (tile.type === "bomb") return;

  tile.revealed = true;

  if (tile.nearbyBombs > 0) return;

  const row = Math.floor(index / 5);
  const col = index % 5;

  for (let rowOffset = -1; rowOffset <= 1; rowOffset++) {
    for (let colOffset = -1; colOffset <= 1; colOffset++) {
      if (rowOffset === 0 && colOffset === 0) continue;

      const nextRow = row + rowOffset;
      const nextCol = col + colOffset;

      if (
        nextRow >= 0 &&
        nextRow < 5 &&
        nextCol >= 0 &&
        nextCol < 5
      ) {
        revealConnected(nextRow * 5 + nextCol);
      }
    }
  }
};

revealConnected(tileId);

  const safeTiles = updatedTiles.filter((tile) => tile.type !== "bomb");
  const revealedSafeTiles = safeTiles.filter((tile) => tile.revealed);

  if (revealedSafeTiles.length === safeTiles.length) {
    const fortune =
      screeningFortunes[
        Math.floor(Math.random() * screeningFortunes.length)
      ];

    const finalMessage = `📽 Congratulations!!!\n\n${fortune}`;

    setSweepTiles(updatedTiles);
    setSweepGameOver(true);
    setSweepMessage(finalMessage);

    await saveMiniGameProgress({
      sweepTiles: updatedTiles,
      sweepGameOver: true,
      sweepMessage: finalMessage,
    });

    return;
  }

  const nextMessage =
    selected.type === "masterpiece"
      ? "🍿 Masterpiece clue found. Keep clearing the board."
      : "Safe clue. Keep sweeping.";

  setSweepTiles(updatedTiles);
  setSweepMessage(nextMessage);

  await saveMiniGameProgress({
    sweepTiles: updatedTiles,
    sweepGameOver: false,
    sweepMessage: nextMessage,
  });
};

const loadMiniGameProgress = async () => {
  if (!user) return;

  const progressRef = doc(db, "users", user.uid, "gameProgress", todayKey);
  const progressSnap = await getDoc(progressRef);

  if (!progressSnap.exists()) return;

  const data = progressSnap.data();

  if (typeof data.puzzlesAnswered === "number") {
    setPuzzlesAnswered(data.puzzlesAnswered);
  }

  if (data.movieGuess) {
    setMovieGuess(data.movieGuess);
  }

  if (
  Array.isArray(data.sweepTiles) &&
  data.sweepTiles.length === 25
) {
  setSweepTiles(data.sweepTiles);
}

  if (typeof data.sweepGameOver === "boolean") {
    setSweepGameOver(data.sweepGameOver);
  }

  if (typeof data.sweepMessage === "string") {
    setSweepMessage(data.sweepMessage);
  }
};

useEffect(() => {
  if (!user) return;
  loadMiniGameProgress();
}, [user]);

useEffect(() => {
  if (!afterHoursFullscreen) return;

  if (!Array.isArray(sweepTiles) || sweepTiles.length !== 25) {
    startLetterboxdSweep();
  }
}, [afterHoursFullscreen, sweepTiles]);

const handleMovieGuess = async (choice) => {
  if (!dailyGame || movieGuess) return;

  setMovieGuess(choice);

  await saveMiniGameProgress({
    movieGuess: choice,
  });
};

const getFallbackDispatchLinks = () => [
  {
    title: `Open ${dispatchSources[dispatchSource]}`,
    link:
      dispatchSource === "a24"
        ? "https://www.reddit.com/r/A24/new/"
        : dispatchSource === "criterion"
        ? "https://www.reddit.com/r/criterion/new/"
        : dispatchSource === "mubi"
        ? "https://www.reddit.com/r/MUBI/new/"
        : "https://www.reddit.com/r/Letterboxd/new/",
  },
];

console.log("Loading dispatch:", dispatchSource);

const loadCineasteNews = async () => {
  setLoadingNews(true);

  const cacheKey = `cineaste-dispatch-${dispatchSource}`;

  try {
    const response = await fetch(
      `/api/cineaste-news?source=${dispatchSource}`
    );

    const data = await response.json();
    const items = data.items || [];

    if (items.length > 0) {
      setCineasteNews(items);
      localStorage.setItem(cacheKey, JSON.stringify(items));
    } else {
      const cached = localStorage.getItem(cacheKey);

      setCineasteNews(
        cached ? JSON.parse(cached) : getFallbackDispatchLinks()
      );
    }
  } catch {
    const cached = localStorage.getItem(cacheKey);

    setCineasteNews(
      cached ? JSON.parse(cached) : getFallbackDispatchLinks()
    );
  }

  setLoadingNews(false);

};

useEffect(() => {
  if (!showCineasteNews) return;

  loadCineasteNews();
}, [showCineasteNews, dispatchSource]);

const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
const [showTerms, setShowTerms] = useState(false);
const [showContact, setShowContact] = useState(false);
const [legalPage, setLegalPage] = useState("");

const handleUpgrade = async () => {
  const user = auth.currentUser;

  if (!user) {
    alert("Please sign in first.");
    return;
  }

  let unsubscribeCheckout = () => {};
  let timeoutId;

  const stopListening = () => {
    unsubscribeCheckout();
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  try {
    setLoadingCheckout(true);

    const checkoutSessionRef = await addDoc(
      collection(
        db,
        "customers",
        user.uid,
        "checkout_sessions"
      ),
      {
        client: "web",
        mode: "payment",
        price: "price_1Tusd0GIyTQwwjnmhnwKJ8x0",
        success_url: `${window.location.origin}?success=true`,
        cancel_url: window.location.origin,
      }
    );

    // Prevent the button from remaining stuck indefinitely.
    timeoutId = setTimeout(() => {
      stopListening();
      setLoadingCheckout(false);
      alert(
        "Checkout is taking longer than expected. Please try again."
      );
    }, 20000);

    unsubscribeCheckout = onSnapshot(
      checkoutSessionRef,
      (snap) => {
        const data = snap.data();

        if (data?.error) {
          stopListening();
          setLoadingCheckout(false);

          const message =
            typeof data.error === "string"
              ? data.error
              : data.error.message || "Unable to start checkout.";

          alert(message);
          return;
        }

        if (data?.url) {
          const checkoutUrl = data.url;

          stopListening();
          setLoadingCheckout(false);

          window.location.assign(checkoutUrl);
        }
      },
      (error) => {
        stopListening();
        setLoadingCheckout(false);
        console.error("Checkout listener failed:", error);
        alert("Unable to load checkout. Please try again.");
      }
    );
  } catch (err) {
    stopListening();
    setLoadingCheckout(false);
    console.error("Checkout creation failed:", err);
    alert(err.message || "Unable to start checkout.");
  }
};


const [loadingCheckout, setLoadingCheckout] = useState(false);
const [showPremiumWelcome, setShowPremiumWelcome] = useState(false);

useEffect(() => {
  if (!user || !premium) return;

  const params = new URLSearchParams(window.location.search);

  if (params.get("success") === "true") {
    setShowPremiumWelcome(true);

    // Remove ?success=true so it doesn't show again
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    );
  }
}, [user, premium]);
const getWikipediaUrl = async (title) => {
  const alias = resolveMovieAlias(title);

  try {
    let imdbId = alias.imdbId || "";

    // Get the movie's IMDb ID from OMDb if the alias does not have one
    if (!imdbId) {
      const omdbMovie = await fetchOmdbMovie(title);

      if (omdbMovie?.imdbID) {
        imdbId = omdbMovie.imdbID;
      }
    }

    // Use the IMDb ID to find the exact Wikipedia page through Wikidata
    if (imdbId) {
      const sparqlQuery = `
        SELECT ?article WHERE {
          ?movie wdt:P345 "${imdbId}".
          ?article schema:about ?movie;
                   schema:isPartOf <https://en.wikipedia.org/>.
        }
        LIMIT 1
      `;

      const response = await fetch(
        "https://query.wikidata.org/sparql?" +
          new URLSearchParams({
            query: sparqlQuery,
            format: "json",
          }),
        {
          headers: {
            Accept: "application/sparql-results+json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();

        const exactWikipediaUrl =
          data?.results?.bindings?.[0]?.article?.value;

        if (exactWikipediaUrl) {
          return exactWikipediaUrl;
        }
      }
    }

    // Use a manually saved Wikipedia page if one exists
    if (alias.wikipedia) {
      return (
        "https://en.wikipedia.org/wiki/" +
        alias.wikipedia
      );
    }

    // Final fallback: Wikipedia search
    const omdbMovie = await fetchOmdbMovie(title);

    const searchTitle =
      omdbMovie?.Title ||
      alias.title ||
      title;

    const searchYear =
      omdbMovie?.Year?.match(/\d{4}/)?.[0] ||
      alias.year ||
      "";

    return (
      "https://en.wikipedia.org/w/index.php?search=" +
      encodeURIComponent(
        `${searchTitle} ${searchYear} film`.trim()
      )
    );
  } catch (error) {
    console.error(
      `Wikipedia lookup failed for "${title}":`,
      error
    );

    return (
      "https://en.wikipedia.org/w/index.php?search=" +
      encodeURIComponent(`${title} film`)
    );
  }
};


const openWikipedia = async (title) => {
  const wikiWindow = window.open("", "_blank");

  try {
    const wikipediaUrl = await getWikipediaUrl(title);

    if (wikiWindow) {
      wikiWindow.location.href = wikipediaUrl;
    }
  } catch (error) {
    console.error(
      `Could not open Wikipedia for "${title}":`,
      error
    );

    if (wikiWindow) {
      wikiWindow.close();
    }
  }
};

  return (

    <div
      className={`app ${slowBurnMode ? "slow-burn-mode" : ""} ${
        user ? "logged-in" : "logged-out"
      }`}
      style={{
        backgroundImage: `
          linear-gradient(
            rgba(10,8,6,0.35),
            rgba(10,8,6,0.48)
          ),
          url(${loginBg})
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "scroll",
      }}
    >
      {!user ? (
  <div className="auth-screen">
    <div className="auth-layout">

      <div className="auth-features">
        <div className="login-brand">
          <img
            src="/popcorn1.png"
            alt="Cineaste Logo"
            className="login-logo"
          />

          <h1>Cineaste</h1>
        </div>

        <p className="auth-tagline">
          Say goodbye to film choice paralysis.
        </p>

        <div className="feature-list">
          <div className="feature-item">
            <img src="/icons/dice.png" alt="" />
            <div>
              <h3>Tonight&apos;s Pick</h3>
              <p>Stop scrolling. Start watching.</p>
            </div>
          </div>

          <div className="feature-item">
            <img src="/icons/cineword.png" alt="" />
            <div>
              <h3>CineWord</h3>
              <p>The daily movie Wordle.</p>
            </div>
          </div>

          <div className="feature-item">
            <img src="/icons/lounge.png" alt="" />
            <div>
              <h3>After-Hours Lounge</h3>
              <p>Relax with Cineaste Radio and games after the credits roll.</p>
            </div>
          </div>

          <div className="feature-item">
            <img src="/icons/dispatch.png" alt="" />
            <div>
              <h3>Cineaste Dispatch</h3>
              <p>Your cinema newsstand.</p>
            </div>
          </div>

          <div className="feature-item">
  <img
    src="/icons/checklists.png"
    alt=""
    aria-hidden="true"
  />

  <div>
    <h3>Curated Checklists</h3>
    <p>Explore hand-picked movie collections across genres.</p>
  </div>
</div>

<div className="feature-item">
  <img
    src="/icons/film-companion.png"
    alt=""
    aria-hidden="true"
  />

  <div>
    <h3>Film Companion</h3>
    <p>Plots, ratings, awards and useful film links in one place.</p>
  </div>
</div>

          <div className="feature-item">
            <img src="/icons/memory.png" alt="" />
            <div>
              <h3>Tonight&apos;s Memory</h3>
              <p>Remember every movie that mattered.</p>
            </div>
          </div>

          <div className="feature-item">
            <img src="/icons/sweep.png" alt="" />
            <div>
              <h3>Cineaste Sweep</h3>
              <p>Discover hidden gems through play.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="auth-card">
        <div className="login-brand auth-card-brand">
          <img
            src="/popcorn1.png"
            alt="Cineaste Logo"
            className="login-logo"
          />

          <h1>
            {authMode === "login"
              ? "Hello."
              : "Join Cineaste"}
          </h1>
        </div>

        <p className="auth-card-subtitle">
          {authMode === "login"
            ? "Your next screening is waiting."
            : "Create your account and start discovering films."}
        </p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          onClick={handleAuth}
          disabled={loadingLogin || loadingSignup}
        >
          {authMode === "login"
            ? loadingLogin
              ? "Entering Cineaste..."
              : "Log In"
            : loadingSignup
              ? "Creating account..."
              : "Create Account"}
        </button>


<button
  className="google-signin-button"
  type="button"
  onClick={async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Google sign-in failed:", error.code);
      alert("Google sign-in failed. Please try again.");
    }
  }}
>
  <img
    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
    alt=""
    width="16"
    height="16"
  />
  Continue with Google
</button>




        {authMode === "login" ? (
          <p
            className="auth-link"
            onClick={() => {
              setAuthMode("signup");
              setAuthError("");
            }}
          >
            Create an account
            <span className="auth-arrow">→</span>
          </p>
        ) : (
          <p
            className="auth-link"
            onClick={() => {
              setAuthMode("login");
              setAuthError("");
            }}
          >
            <span className="auth-arrow">←</span>
            Back to Sign In
          </p>
        )}

        {authError && (
          <p className="auth-error">
            {authError}
          </p>
        )}
      </div>

    </div>
  </div>
) : checkingPremium ? (
        <div className="auth-screen">
          <div className="auth-card">
            <h1>Cineaste</h1>
            <p>Preparing tonight's screening...</p>
            <img
              src="/screening.gif"
              alt="Preparing screening"
              className="screening-gif"
            />
          </div>
        </div>
      ) : (
        
        <>

          {slowBurnMode && (
            <section className="slowburn-panel">
              <div className="slowburn-panel-header">
                <div>
                  <p className="slowburn-label">After-Hours Radio</p>
                  <h3>{somaStation.title}</h3>
                  <p className="slowburn-mood">{somaStation.mood}</p>

                  <div className="soma-now-playing">
                    <span className="soma-live-dot" />

                    <p className="now-playing-title">
                      Now playing:{" "}
                      {nowPlaying?.artist && nowPlaying?.song
                        ? `${nowPlaying.artist} — ${nowPlaying.song}`
                        : nowPlaying?.title
                        ? nowPlaying.title
                        : nowPlaying?.track
                        ? nowPlaying.track
                        : "Loading current track..."}
                    </p>
                  </div>
                  
  
                </div>
                                <span className="slowburn-live">On Air</span>
              </div>

              <div className="soma-minimal-player">
                <audio
  ref={audioRef}
  controls
  autoPlay
  playsInline
  className="soma-player"
>
  <source src={somaStation.stream} type="audio/mpeg" />
</audio>

                <div className="radio-button-row">
    <button
      type="button"
      className="radio-next-button"
      onClick={changeSomaStation}
    >
      Change frequency
    </button>

  </div>
  </div>
            </section>
          )}

          <div className="top-nav-row">
            <button
              type="button"
              className="cineaste-logout-button"
              onClick={handleLogout}
            >
              Log Out
            </button>
          </div>

          <header className="hero">
            <div>
              <div className="brand">
                <div className="cineaste-logo">
                  <div className="pixel-popcorn">
                    <div className="popcorn-top"></div>
                    <div className="popcorn-bucket"></div>
                  </div>
                </div>

                <h1>Cineaste</h1>
              </div>

              <p>Choose Less. Watch More.</p>

              <p className="disclaimer-text">
                Independent cinematic discovery experience.
                <br />
                Not affiliated with Letterboxd, Spotify, Rotten Tomatoes,
                Wikipedia, A24, or MUBI.
              </p>

              <div className="hero-top-row">
                <div className="hero-actions-column">
                  <button
                    type="button"
                    className="watch-inspired-button"
                    onClick={() => setShowHowToUse(!showHowToUse)}
                  >
                    How to use
                  </button>

                  <button
                    type="button"
                    className="slowburn-button"
                    onClick={() => {
                      if (slowBurnMode) {
                        stopSlowBurn();
                      } else {
                        startSlowBurn();
                      }
                    }}
                  >
                    {slowBurnMode
                      ? "☀ Exit After-Hours Radio"
                      : "🌙 Enter After-Hours Radio"}
                  </button>

                  <button
  type="button"
  className="watch-inspired-button"
  onClick={() => {
  if (!slowBurnMode) {
    startSlowBurn();
  }

  setAfterHoursFullscreen(true);
}}
>
  🌙 Enter the After-Hours Lounge
</button>


                  <button
                    type="button"
                    className="watch-inspired-button"
                    onClick={handleWatchInspired}
                  >
                    Late-night thought
                  </button>

             {!premium && (
  <button
  type="button"
  className="watch-inspired-button"
  onClick={handleUpgrade}
  disabled={loadingCheckout}
>
  {loadingCheckout
    ? "Opening Secure Checkout..."
    : "✨ Upgrade to Premium"}
</button>
)}


                  {showHowToUse && (
                    <div className="watch-inspired-card">
                      <p>
                        HOW TO ADD CINEASTE APP TO YOUR PHONE:
<br />
                        <br />
1. iPhone: Open Cineaste in Safari, tap the Share button, scroll down, tap Add to Home Screen, then tap Add.
<br />
                        <br />
2. Android: Open Cineaste in Chrome, tap the three-dot menu, tap Add to Home screen or Install app, then tap Add.
<br />
         
                        <br />
                        Curated in batches. Complete each list to unlock your
                        next discovery session.
                        <br />
                        <br />
                        Click any movie title to open its Letterboxd page.
                        <br />
                        <br />
                        Use the icons below each film for plot, ratings,
                        soundtrack, awards, and more.
                        <br />
                        <br />
                        Refresh List unlocks after completing the current batch to view a new list.
                        <br />
                        <br />
                        Tonight’s Pick is a random recommendation from your
                        current batch. Use it when you can’t decide what to
                        watch.
                        <br />
                        <br />
                        The Cinema Profile tracks your progress and reveals
                        personalized titles as you watch more.
                        <br />
                        <br />
                        Late-night thought: A new cinematic reflection appears
                        every 24 hours.
                      </p>
                    </div>
                  )}

                  {showWatchInspired && watchInspiredQuote && (
                    <div className="watch-inspired-card">
                      <p>“{watchInspiredQuote.quote}”</p>
                      <span>— {watchInspiredQuote.author}</span>
                    </div>
                  )}
                </div>

                <div className="cinema-profile-card">
                  <p className="cinema-profile-label">Cinema Profile</p>

                  <h3>{cinemaProfile.profileTitle}</h3>

                  <span>{cinemaProfile.totalWatched} films watched</span>

                  {cinemaProfile.nextGoal ? (
                    <span>
                      Next: {cinemaProfile.nextTitle} at{" "}
                      {cinemaProfile.nextGoal}
                    </span>
                  ) : (
                    <span>{cinemaProfile.nextTitle}</span>
                  )}

                  <span>Most explored: {cinemaProfile.topCategory}</span>
                </div>
              </div>

              <br />
            </div>
          </header>

          <section className="controls">
            <input
              type="text"
              placeholder="Search movies..."
              value={search}
              onChange={(event) => {
                setSearch(event.target.value);
                setSelectedCategory(null);
              }}
            />

            <div className="add-list-section">
              <h3>Add Letterboxd List</h3>

              <div className="custom-list-form">
                <input
                  type="text"
                  placeholder="List name"
                  value={listName}
                  onChange={(event) => setListName(event.target.value)}
                />

                <input
                  type="text"
                  placeholder="Paste Letterboxd list URL"
                  value={listUrl}
                  onChange={(event) => setListUrl(event.target.value)}
                />

                <button type="button" onClick={addCustomList}>
                  Save List
                </button>
              </div>
            </div>
          </section>

          {!selectedCategory && (
            <main className="category-grid">
              {customLists.length > 0 && (
                <button
                  type="button"
                  className="category-card"
                  onClick={() => setSelectedCategory("My Added Lists")}
                >
                  <div>
                    <h2>My Added Lists</h2>
                    <p>{customLists.length} saved Letterboxd lists</p>
                  </div>

                  <div className="progress-badge">↗</div>
                </button>
              )}

              {[
  ...Object.entries(visibleCategories).filter(
    ([category]) =>
      premium || !lockedCategories.includes(category)
  ),
  ...(!premium
    ? Object.entries(visibleCategories).filter(([category]) =>
        lockedCategories.includes(category)
      )
    : []),
].map(([category, movies]) => {

                const isLocked = !premium && lockedCategories.includes(category);

                const progress = getProgress(category, movieData[category]);

                return (

                  <button
  type="button"
  className={`category-card category-${category
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")} ${isLocked ? "locked-category" : ""}`}
  key={category}
  onClick={() => {
    if (isLocked) {
      alert(
        "🔒 This collection is available with Cineaste Premium."
      );
      return;
    }

    setIsOpeningCategory(true);

    setTimeout(() => {
      setSelectedCategory(category);
      setIsOpeningCategory(false);
    }, 120);
  }}
>
  <div>
    <h2>
      {category}
      {isLocked && " 🔒"}
    </h2>
  </div>

  <div className="progress-badge">{progress}%</div>
</button>
                );
              })}
            </main>
          )}

          {selectedCategory === "My Added Lists" && (
            <main className="movie-detail">
              <button
                type="button"
                className="back-button"
                onClick={() => {
                  setIsOpeningCategory(true);

                  setTimeout(() => {
                    setSelectedCategory(null);
                    setIsOpeningCategory(false);
                  }, 120);
                }}
              >
                ← Return to lists
              </button>

              <section className="movie-card">
                <div className="card-header">
                  <div>
                    <h2>My Added Lists</h2>
                    <p>{customLists.length} saved lists</p>
                  </div>
                </div>

                <div className="movie-list">
                  {customLists.map((list) => (
                    <div
                      className="movie-row custom-list-card"
                      key={list.url}
                    >
                      <input type="checkbox" />

                      <div className="custom-list-info">
                        <button
                          type="button"
                          className="movie-link"
                          onClick={() => window.location.assign(list.url)}
                        >
                          {list.name}
                        </button>

                        <button
                          type="button"
                          className="delete-list-button"
                          onClick={() => deleteCustomList(list.url)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </main>
          )}

          {selectedCategory && selectedCategory !== "My Added Lists" && (
            <div className={`category-view ${isOpeningCategory ? "opening" : ""}`}>
              <main className="movie-detail">
                <button
                  type="button"
                  className="back-button"
                  onClick={() => {
                    setIsOpeningCategory(true);

                    setTimeout(() => {
                      setSelectedCategory(null);
                      setIsOpeningCategory(false);
                    }, 120);
                  }}
                >
                  ← Return to lists
                </button>

                  

                <section className="movie-card">
                  <div className="card-header">
                    <button
                      type="button"
                      className={`refresh-list-button ${
                        getProgress(selectedCategory, moviesToShow) < 100
                          ? "disabled-refresh"
                          : ""
                      }`}
                      disabled={false}
                      title={
                        getProgress(selectedCategory, moviesToShow) < 100
                          ? "Watch everything below first"
                          : "Load a new curated batch"
                      }
                      onClick={() => {
                        if (getProgress(selectedCategory, moviesToShow) < 100) {
                          alert(
                            "Behave. Decide based on the list provided. Watch all of these first!"
                          );
                          return;
                        }

                        refreshCategory(selectedCategory);
                      }}
                    >
                      Refresh List
                    </button>

                    <div>
                      <h2>{selectedCategory}</h2>
                      <p>{moviesToShow.length} movies</p>
                    </div>

                    <div className="progress-badge">
                      {getProgress(selectedCategory, moviesToShow)}%
                    </div>
                  </div>

                  <div className="progress-bar">
                    <div
                      style={{
                        width: `${getProgress(
                          selectedCategory,
                          moviesToShow
                        )}%`,
                      }}
                    />
                  </div>

                  <button
                    type="button"
                    className="tonights-pick-button"
                    onClick={chooseTonightsPick}
                  >
                    Tonight’s Pick
                  </button>

                  {tonightsPick && (
                    <div className="tonights-pick-card">
                      <p className="tonights-pick-label">Tonight’s Pick</p>

                      <button
                        type="button"
                        className="tonights-pick-title"
                        onClick={() => openLetterboxd(tonightsPick[0])}
                      >
                        {tonightsPick[0]}
                      </button>

                      <p className="tonights-pick-copy">
                        Stop scrolling. This is tonight’s film.
                      </p>
                    </div>
                  )}

                  <div className="movie-list">
                    {moviesToShow.map(([title]) => {
                      const key = `${selectedCategory}-${title}`;
                      const isWatched = !!watched[key];

                      return (
                        <div className="movie-row" key={key}>
                          <input
                            type="checkbox"
                            checked={isWatched}
                            onChange={() =>
                              toggleMovie(selectedCategory, title)
                            }
                          />

                          <div className="movie-info">
                            <button
                              type="button"
                              className={
                                isWatched
                                  ? "movie-link watched"
                                  : "movie-link"
                              }
                              onClick={() => openLetterboxd(title)}
                            >
                              {title}
                            </button>

                            <p className="movie-plot">
                              {loadingPlots[title]
                                ? "Loading plot..."
                                : plots[title] || ""}
                            </p>

                            <div className="movie-actions">
                              <button
                                type="button"
                                className="plot-button"
                                onClick={() => fetchMoviePlot(title)}
                              >
                                📖 Plot
                              </button>

                              <button
                                type="button"
                                className="rt-button"
                                onClick={() =>
                                  fetchRottenTomatoesRating(title)
                                }
                              >
                                🍅{" "}
                                {loadingRatings[title]
                                  ? "Loading..."
                                  : rtRatings[title] || "RT"}
                              </button>

                              <button
                                type="button"
                                className="spotify-button"
                                onClick={() => {
                                  window.location.href = `spotify:search:${encodeURIComponent(
                                    title + " soundtrack"
                                  )}`;
                                }}
                              >
                                🎵 Soundtrack
                              </button>

                              <button
                                type="button"
                                className="awards-button"
                                onClick={() => fetchMovieAwards(title)}
                              >
                                🏆 {awards[title] || "Awards"}
                              </button>

<button
  type="button"
  className="wiki-button"
  onClick={() => openWikipedia(title)}
>
  📚 Wiki
</button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="bottom-back-button-wrap">
  <button
    type="button"
    className="back-button bottom-back-button"
    onClick={() => {
      setIsOpeningCategory(true);

      setTimeout(() => {
        setSelectedCategory(null);
        setIsOpeningCategory(false);
      }, 120);
    }}
  >
    ← Return to lists
  </button>
</div>
                </section>
              </main>
              </div>
          )}

         {afterHoursFullscreen && (
  <section className="screening-room">
    <div className="screening-room-bg" />

    <button
      type="button"
      className="screening-room-exit"
      onClick={() => setAfterHoursFullscreen(false)}
    >
      Exit
    </button>

    <div className="screening-room-card">
      <p className="screening-room-label">Cineaste After-Hours Lounge</p>

      <div className="screening-room-time">
        <span>{currentTime || "Now"}</span>
        <span>{userLocation || "Your location"}</span>
      </div>

      <h1>{somaStation.title}</h1>

      <div className="screening-room-track">
        <span className="screening-room-dot" />

        <div>
          <p>Now playing</p>
          <h3>
            {nowPlaying?.artist && nowPlaying?.song
              ? `${nowPlaying.artist} — ${nowPlaying.song}`
              : nowPlaying?.title
              ? nowPlaying.title
              : nowPlaying?.track
              ? nowPlaying.track
              : "Loading current track..."}
          </h3>
        </div>
      </div>
    
    <div className="cineaste-news">
  <div className="cineaste-news-header">
    <h3>Cineaste Dispatch</h3>

    <button
      type="button"
      className="radio-next-button cineaste-news-toggle"
      onClick={() => setShowCineasteNews(!showCineasteNews)}
    >
      {showCineasteNews ? "Hide" : "Show"}
    </button>
  </div>

  {showCineasteNews && (
    <>

        <div className="dispatch-tabs">
      {Object.entries(dispatchSources).map(([key, label]) => (
        <button
          type="button"
          key={key}
          className={dispatchSource === key ? "active" : ""}
          onClick={() => setDispatchSource(key)}
        >
          {label}
        </button>
      ))}
    </div>

      {loadingNews ? (
        <p className="screening-room-result">
          Gathering dispatches...
        </p>
      ) : cineasteNews.length > 0 ? (
  <>
    <div className="cineaste-news-list">
      {cineasteNews.slice(0, 10).map((item) => (
        <button
          type="button"
          key={item.link}
          className="cineaste-news-item"
          onClick={() => {
  if (/iPhone|iPad|Android/i.test(navigator.userAgent)) {
    window.location.href = item.link;
  } else {
    window.open(
      item.link,
      "_blank",
      "noopener,noreferrer"
    );
  }
}}
        >
          <span>{item.title}</span>
{item.meta && <small>{item.meta}</small>}
        </button>
      ))}
    </div>
  </>
) : (

          <p className="screening-room-result">
          The booth is quiet. Open a community instead.
        </p>
      )}
    </>
  )}
</div>

<CineWord user={user} />
      <div className="screening-room-game">
  <p className="screening-room-game-label">Tonight’s Mini Game</p>

  <h3>Guess the film from the mood</h3>

  {puzzlesAnswered < 2 && dailyGame ? (
    <>
      <div className="screening-room-clues">
        {dailyGame.clue.map((word) => (
          <span key={word}>{word}</span>
        ))}
      </div>

      <div className="screening-room-choices">
        {dailyGame.choices.map((choice) => (
          <button
            type="button"
            key={choice}
            onClick={() => handleMovieGuess(choice)}
            disabled={!!movieGuess}
          >
            {choice}
          </button>
        ))}
      </div>

      {movieGuess && (
        <>
          <p className="screening-room-result">
            {movieGuess === dailyGame.answer
              ? "Correct. You found tonight’s film."
              : `Not quite. Tonight’s film was ${dailyGame.answer}.`}
          </p>

          <button
            type="button"
            className="screening-room-next-puzzle"
            onClick={goToNextPuzzle}
          >
            {puzzlesAnswered === 0 ? "Next puzzle" : "Finish tonight’s game"}
          </button>
        </>
      )}
    </>
  ) : (
    <>
      <p className="screening-room-result">
        You’ve completed tonight’s two puzzles. Come back tomorrow for a new pair.
      </p>

    
    </>
  )}
</div>

<div className="letterboxd-sweep">
  <div className="sweep-header-row">
    <h3>Cineaste Sweep</h3>

    <button
      type="button"
      className="radio-next-button"
      style={{
        marginTop: "6px",
        padding: "6px 10px",
        fontSize: "0.68rem",
        width: "fit-content",
      }}
      onClick={() =>
        setShowSweepGame(!showSweepGame)
      }
    >
      {showSweepGame ? "Hide game" : "Show game"}
    </button>
  </div>

  {showSweepGame && (
    <>
      <h3>
        What's your screening fortune?
      </h3>

      <div className="sweep-grid">
        {sweepTiles.map((tile) => (
          <button
            type="button"
            key={tile.id}
            className={`sweep-tile ${
              tile.revealed ? "revealed" : ""
            }`}
            onClick={() =>
              revealSweepTile(tile.id)
            }
            disabled={
              tile.revealed || sweepGameOver
            }
          >
            {tile.revealed
  ? tile.type === "bomb"
    ? "💣"
    : tile.type === "masterpiece"
    ? "🍿"
    : tile.nearbyBombs > 0
    ? tile.nearbyBombs
    : ""
  : "▦"}
          </button>
        ))}
      </div>

      <p
  className="screening-room-result"
  style={{ whiteSpace: "pre-line" }}
>
  {sweepMessage}
</p>

      {sweepGameOver && (
        <button
          type="button"
          className="screening-room-next-puzzle"
          onClick={startLetterboxdSweep}
        >
          New sweep
        </button>
      )}
    </>
  )}
</div>

<div className="screening-room-journal">
  <div className="journal-header-row">
    <p className="screening-room-journal-label">Tonight’s Memory</p>
  </div>
<div className="journal-title-wrapper">
<input
  className="screening-room-journal-title"
  placeholder="Give this memory a title..."
  value={journalTitle}
  onChange={(e) => setJournalTitle(e.target.value)}
/>
</div>
  <textarea
    className="screening-room-journal-input"
    placeholder="What scene, feeling, or memory stayed with you tonight..."
    value={journalText}
    onChange={(e) => setJournalText(e.target.value)}
  />

  <div className="journal-button-row">
    <button
  type="button"
  className={`radio-next-button ${journalSaved ? "saved" : ""}`}
  disabled={savingMemory || !journalText.trim()}
  onClick={() => saveJournalToCloud(journalText)}
>
  {savingMemory
  ? "Saving..."
  : journalSaved
  ? "Saved"
  : "Save memory"}
</button>

    <button
  type="button"
  className="radio-next-button"
  style={{ marginTop: "10px" }}
  onClick={loadJournalArchive}
>
  View saved memories
</button>
  </div>

  <p className="screening-room-journal-footer">
    Written somewhere after midnight.
  </p>

  {showMemoryArchive && (
  <div className="memory-archive">
    <p className="screening-room-journal-label">
      Saved Memories
    </p>

    {groupedJournalEntries.map(([year, entries]) => (
      <div
  key={year}
  className={`memory-year-group ${
    openedYear === year ? "open" : ""
  }`}
>
        <button
          type="button"
          className="memory-year-button"
          onClick={() =>
            setOpenedYear(
              openedYear === year ? null : year
            )
          }
        >
          <>
  {year}
</>
        </button>

        {openedYear === year && (
          <div className="memory-year-entries">
            {entries.map((entry) => (
              <div
  className="memory-entry"
  key={entry.id}
  onClick={() =>
    setOpenMemoryId(
      openMemoryId === entry.id ? null : entry.id
    )
  }
>
                <strong>{entry.date}</strong>
             <button
  type="button"
  className="memory-delete-x"
  disabled={deletingMemoryId === entry.id}
  onClick={(e) => {
  e.stopPropagation();
  setMemoryToDelete(entry);
}}
>
  {deletingMemoryId === entry.id ? "…" : "×"}
</button>

                <span>  
                  {entry.title || "Untitled memory"}
                </span>

                <div
  className={`memory-entry-content ${
    openMemoryId === entry.id ? "open" : ""
  }`}
>
  <p>{entry.text}</p>
</div>
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
)}
    </div>
    
      <p className="screening-room-mood">{somaStation.mood}</p>

      <div className="screening-room-actions">
  <button
    type="button"
    onClick={() => {
      audioRef.current?.play();
    }}
  >
    ▶ Play
  </button>

  <button
    type="button"
    onClick={() => {
      audioRef.current?.pause();
    }}
  >
    ❚❚ Pause
  </button>
        <button type="button" onClick={changeSomaStation}>
          Change Frequency
        </button>

        <button
          type="button"
          onClick={() => setAfterHoursFullscreen(false)}
        >
          Back to Films
        </button>

       
      </div>

      {memoryToDelete && (
  <div
    className="memory-delete-overlay"
    onClick={() => setMemoryToDelete(null)}
  >
    <div
      className="memory-delete-modal"
      onClick={(e) => e.stopPropagation()}
    >

      <h3>Do you want to erase this memory?</h3>

      <p className="memory-delete-title">
        {memoryToDelete.title || "Untitled memory"}
      </p>

      <div className="memory-delete-actions">
        <button
          type="button"
          onClick={() => setMemoryToDelete(null)}
        >
          No
        </button>

        <button
          type="button"
          className="memory-delete-confirm"
          onClick={() => {
            const id = memoryToDelete.id;
            setMemoryToDelete(null);
            deleteJournalEntry(id);
          }}
        >
          Yes
        </button>
      </div>
    </div>
  </div>
)}
           </div>
  </section>
  

)}
        </>
      )}
<footer className="cineaste-footer">

  <div className="footer-logo">
    🎬 Cineaste
  </div>

  <p className="footer-tagline">
    Say goodbye to film choice paralysis.
  </p>

  <div className="footer-links">

    <button
      type="button"
      className="footer-link"
      onClick={() => setLegalPage("privacy")}
    >
      Privacy Policy
    </button>

    <span>·</span>

    <button
      type="button"
      className="footer-link"
      onClick={() => setLegalPage("terms")}
    >
      Terms
    </button>

    <span>·</span>

    <button
      type="button"
      className="footer-link"
      onClick={() => setLegalPage("contact")}
    >
      Contact
    </button>

    <span>·</span>

<button
  type="button"
  className="footer-link"
  onClick={() => setLegalPage("about")}
>
  About
</button>

  </div>

  <p className="footer-copyright">
    © 2026 Cineaste
  </p>

</footer>

{legalPage && (
  <div
    className="modal-overlay"
    onClick={() => setLegalPage("")}
  >
    <div
  className="legal-modal"
  onClick={(e) => e.stopPropagation()}
>
      {legalPage === "privacy" && (
        <>
  <h2>Privacy Policy</h2>

  <p className="legal-date">
    Last Updated: July 14, 2026
  </p>

  <h3>1. Information We Collect</h3>

  <p>
    When you create a Cineaste account, we may collect your email address,
    authentication information through Firebase Authentication, and the
    information you choose to save within your account.
  </p>

  <ul>
    <li>Email address</li>
    <li>Watched films</li>
    <li>Watchlists</li>
    <li>Custom Letterboxd lists</li>
    <li>Cinema Profile information</li>
    <li>Late-Night Thoughts</li>
    <li>Tonight's Pick</li>
    <li>Tonight's Memory</li>
    <li>Cineaste Sweep progress</li>
    <li>Mini-game progress</li>
    <li>Preferences and settings</li>
  </ul>

  <h3>2. How We Use Your Information</h3>

  <p>
    Your information is used to create and manage your account, synchronize
    your progress across devices, personalize your experience, provide Premium
    features, improve Cineaste, and respond to support requests.
  </p>

  <h3>3. Cloud Storage</h3>

  <p>
    Cineaste securely stores your account data using Google Firebase,
    including Firebase Authentication and Cloud Firestore.
  </p>

  <h3>4. Premium Purchases</h3>

  <p>
    Premium purchases are securely processed through Gumroad. Cineaste does
    not collect or store your payment card information.
  </p>

  <h3>5. Advertising</h3>

  <p>
    Free users may see advertisements within Cineaste. Advertising may be
    provided by Google AdSense or other advertising partners. Premium members
    enjoy an ad-free experience.
  </p>

  <h3>6. Cookies</h3>

  <p>
    Cineaste may use cookies and similar technologies to keep you signed in,
    remember your preferences, improve performance, and support advertising
    services.
  </p>

  <h3>7. Data Security</h3>

  <p>
    We take reasonable measures to protect your information using secure
    industry-standard services. However, no online service can guarantee
    absolute security.
  </p>

  <h3>8. Your Rights</h3>

  <p>
    You may update your profile, modify your saved information, request
    deletion of your account and associated data, or contact us regarding your
    privacy.
  </p>

  <h3>9. Children's Privacy</h3>

  <p>
    Cineaste is not intended for children under the minimum age required by
    applicable law. We do not knowingly collect personal information from
    children.
  </p>

  <h3>10. Changes to This Policy</h3>

  <p>
    We may update this Privacy Policy from time to time. Any changes will be
    posted within Cineaste with an updated revision date.
  </p>

  <h3>11. Contact</h3>

  <p>
    If you have any questions regarding this Privacy Policy, please contact us
    at:
  </p>

  <p>
    <strong>Email:</strong> pameladeramos@cineastefilm.org
  </p>
</>
      )}

      {legalPage === "terms" && (
        <>
  <h2>Terms of Use</h2>

  <p className="legal-date">
    Last Updated: July 14, 2026
  </p>

  <h3>1. Acceptance of Terms</h3>

  <p>
    By creating an account or using Cineaste, you agree to these Terms of Use.
    If you do not agree, please discontinue use of the service.
  </p>

  <h3>2. Accounts</h3>

  <p>
    You are responsible for maintaining the confidentiality of your account
    credentials and for all activity that occurs under your account.
  </p>

  <h3>3. Acceptable Use</h3>

  <p>You agree not to:</p>

  <ul>
    <li>Attempt to gain unauthorized access to Cineaste.</li>
    <li>Interfere with the operation of the platform.</li>
    <li>Upload malicious software or harmful code.</li>
    <li>Use Cineaste for unlawful purposes.</li>
    <li>Copy or redistribute Cineaste without permission.</li>
  </ul>

  <h3>4. User Content</h3>

  <p>
    You retain ownership of the personal content you create within Cineaste.
    By storing your content, you grant Cineaste permission to store and display
    it solely for the purpose of providing the service.
  </p>

  <h3>5. Premium Membership</h3>

  <p>
    Premium subscriptions unlock additional features. Available features may
    change over time as Cineaste continues to evolve.
  </p>

  <h3>6. Advertisements</h3>

  <p>
    Free users may see advertisements within Cineaste. Premium subscribers
    enjoy an ad-free experience.
  </p>

  <h3>7. Intellectual Property</h3>

  <p>
    The Cineaste platform, branding, software, design, and original content
    are protected by copyright and intellectual property laws. Film titles,
    posters, and trademarks remain the property of their respective owners.
  </p>

  <h3>8. Availability</h3>

  <p>
    We strive to keep Cineaste available at all times, but uninterrupted
    service cannot be guaranteed. Maintenance or unforeseen issues may
    temporarily affect availability.
  </p>

  <h3>9. Disclaimer</h3>

  <p>
    Cineaste is provided "as is" without warranties of any kind. We do not
    guarantee that recommendations, external links, or third-party information
    will always be accurate or available.
  </p>

  <h3>10. Limitation of Liability</h3>

  <p>
    To the fullest extent permitted by law, Cineaste shall not be liable for
    indirect, incidental, or consequential damages arising from the use of the
    platform.
  </p>

  <h3>11. Account Suspension</h3>

  <p>
    We reserve the right to suspend or terminate accounts that violate these
    Terms or engage in fraudulent, abusive, or unlawful activity.
  </p>

  <h3>12. Changes to the Service</h3>

  <p>
    Cineaste may modify, remove, or introduce new features at any time without
    prior notice.
  </p>

  <h3>13. Changes to These Terms</h3>

  <p>
    These Terms of Use may be updated periodically. Continued use of Cineaste
    after changes become effective constitutes acceptance of the updated
    Terms.
  </p>

  <h3>14. Contact</h3>

  <p>
    Questions regarding these Terms may be sent to:
  </p>

  <p>
    <strong>Email:</strong> pameladeramos@cineastefilm.org
  </p>
</>
      )}

      {legalPage === "contact" && (
        <>
          <h2>Contact</h2>
          <p>
            Email: pameladeramos@cineastefilm.org
          </p>
        </>
      )}

      {legalPage === "about" && (
  <>
    <h2>About Cineaste</h2>

    <p className="legal-date">
      Version 1.0
    </p>

    <p>
      Cineaste is a home for people who love discovering cinema beyond the
      mainstream.
    </p>

    <p>
      Whether you're exploring timeless classics, acclaimed international
      films, independent gems, or modern masterpieces, Cineaste is designed
      to help you keep track of your journey through film.
    </p>

    <h3>Features</h3>

    <ul>
      <li>Track watched films</li>
      <li>Add your own Letterboxd lists</li>
      <li>Discover curated film collections</li>
      <li>Build your personal Cinema Profile</li>
      <li>Unlock additional features with Cineaste Premium</li>
    </ul>

    <h3>Our Philosophy</h3>

    <p>
      We believe every film has the potential to become someone's favourite.
      Cineaste encourages curiosity, thoughtful discovery, and a deeper
      appreciation for cinema from around the world.
    </p>

    <h3>Created With</h3>

    <p>
  Cineaste was independently designed and developed with care for film lovers
  who believe discovering cinema should be as enjoyable as watching it.
</p>

    <h3>Thank You</h3>

    <p>
      Thank you for being part of the Cineaste community.
      We hope every visit inspires your next unforgettable film.
    </p>
  </>
)}

      <button
  className="legal-close-button"
  onClick={() => setLegalPage("")}
>
  Close
</button>
    </div>
  </div>
)}
{showPremiumWelcome && (
  <div className="premium-modal-overlay">
    <div className="premium-modal">

      <div className="premium-checkmark">
        ✨
      </div>

      <h2>Welcome to Cineaste Premium</h2>

      <p>
        Your payment was successful and Premium has been unlocked.
      </p>

      <div className="premium-benefits">

        <div>✓ Unlimited recommendations</div>

        <div>✓ Premium watchlists</div>

        <div>✓ Future Premium features</div>

      </div>

      <button
        className="premium-button"
        onClick={() => setShowPremiumWelcome(false)}
      >
        Start Exploring
      </button>

    </div>
  </div>
)}
    </div>
  );
}